var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _path, _polygon3, _path2, _polygon4, _path3, _polygon5, _path4, _polygon6, _line, _line2, _path5, _polygon7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCatalogIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g,.j{fill:none;}.b{fill:#3c3c46;opacity:0.2;}.c,.f{fill:#ffefe0;}.c,.d,.e,.f,.g,.h,.i,.j{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d,.e{fill:#fff;}.e,.f,.g,.h,.i{fill-rule:evenodd;}.h{fill:#3ca4ef;}.i{fill:#89d9fb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-catalog-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 15,
    y: 37.78,
    width: 116,
    height: 82.69
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 9,
    y: 31.78,
    width: 58,
    height: 82.69
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 67,
    y: 31.78,
    width: 58,
    height: 82.69
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 25.31,
    y: 31.78,
    width: 93.88,
    height: 82.69
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "114.69 19.53 67 31.78 67 114.47 114.69 102.22 114.69 19.53"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "19.31 19.53 67 31.78 67 114.47 19.31 102.22 19.31 19.53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45,48.62l13.4,3.59M45,43.62l10.7,2.87M45,38.62l13.4,3.59"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "27.95 32.94 38.97 35.9 38.97 48.13 27.95 45.18 27.95 32.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45,68.38,58.36,72M45,63.38,58.36,67M45,58.38l9.35,2.51"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "27.95 52.7 38.97 55.66 38.97 67.89 27.95 64.94 27.95 52.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M92.65,74.82l13.4-4.15m-13.4-.85,13.4-4.15m-13.4-.85L102,61.93"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "75.64 68.97 86.66 65.56 86.66 77.8 75.64 81.2 75.64 68.97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M92.65,94.91l13.4-4.15m-13.4-.85,13.4-4.15m-13.4-.85L102,82"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "75.64 89.05 86.66 85.64 86.66 97.88 75.64 101.29 75.64 89.05"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "j",
    x1: 27.95,
    y1: 79.9,
    x2: 58.36,
    y2: 88.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "j",
    x1: 27.95,
    y1: 85.26,
    x2: 58.36,
    y2: 93.41
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M92.65,54.59l13.4-4.15m-13.4-.85,13.4-4.15m-13.4-.85L102,41.69"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "75.64 48.73 86.66 45.32 86.66 57.56 75.64 60.97 75.64 48.73"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCatalogIcon);
export default __webpack_public_path__ + "static/media/CP-catalog-icon.eeb2b4fb101c03d85084c95362dbd6e3.svg";
export { ForwardRef as ReactComponent };